import styled from 'styled-components'
import RichTextEditor from '@/components/RichTextEditor'

export const TextEditor = styled(RichTextEditor)`
  padding: 0.625rem 1.25rem;
  border-radius: 8px;
`
